import { create } from "zustand";

const STORAGE_KEY = "ordersHiddenColumns";

interface ColumnsOrdersStore {
  hiddenColumns: string[];
  toggleColumn: (key: string) => void;
  resetHiddenColumns: () => void;
}

function getInitialHiddenColumns(): string[] {
  if (typeof window === "undefined") return [];
  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY) ?? "[]") || [];
  } catch {
    return [];
  }
}

function saveToLocalStorage(value: string[]): void {
  if (typeof window !== "undefined") {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  }
}

const useColumnsOrdersStore = create<ColumnsOrdersStore>((set) => ({
  hiddenColumns: getInitialHiddenColumns(),
  toggleColumn: (key: string) =>
    set((state) => {
      const newHidden = state.hiddenColumns.includes(key)
        ? state.hiddenColumns.filter((k) => k !== key)
        : [...state.hiddenColumns, key];
      saveToLocalStorage(newHidden);
      return { hiddenColumns: newHidden };
    }),
  resetHiddenColumns: () => {
    saveToLocalStorage([]);
    set({ hiddenColumns: [] });
  },
}));

export default useColumnsOrdersStore;